import { render, staticRenderFns } from "./timeTag.vue?vue&type=template&id=0c63cad3&scoped=true"
import script from "./timeTag.vue?vue&type=script&lang=js"
export * from "./timeTag.vue?vue&type=script&lang=js"
import style0 from "./timeTag.vue?vue&type=style&index=0&id=0c63cad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c63cad3",
  null
  
)

export default component.exports